import { Modal } from "@/entities/modal";
import PageContext from "@/entities/page.context";

export class AppState {
  pageContext: PageContext = new PageContext();
  isMobileView = false;
  modal: Modal = {};
  messages: Map<string, string> = new Map<string, string>();
  marketResult: Map<string, {answer: string, eventId:string, marketId: string, isSubmited: boolean, submitedAns:string}> = new Map<string, {answer: string, eventId:string, marketId: string, isSubmited: boolean, submitedAns: string}>();
}